import { enGB, de } from 'date-fns/locale'

// InertiaPropsHelper::getLocales() emits `current: []` when the active app locale is not one of the
// UI locales, so a missing current locale is a supported state, not an anomaly. Resolve it to the
// first configured UI locale rather than returning undefined — callers below index into it and format
// with it, and an undefined code used to throw and take whole forms down with it.
export const useCurrentLocale = () => {
  const current = window._locales?.current

  if (current?.code) {
    return current
  }

  return window._locales?.list?.[0] ?? { code: 'en-GB' }
}
export const useCurrentLocaleCode = () => useCurrentLocale().code
export const useSimplifiedCurrentLocale = () =>
  useCurrentLocaleCode().split('-')[0]
export const useLocaleList = () => window._locales.list
export const useDateFnsLocales = () =>
  useCurrentLocaleCode() === 'de-DE' ? de : enGB
export const getTranslation = (textObject) => {
  return textObject[useCurrentLocaleCode()] ?? Object.values(textObject)[0]
}
